export const BATCH_SIZE = 3;
export const MIN_DELAY_BETWEEN_BATCH_REQ = 5;
export const MAX_DELAY_BETWEEN_BATCH_REQ = 15;